import { render, staticRenderFns } from "./ThemesEditorAddModal.vue?vue&type=template&id=ca8b7204"
import script from "./ThemesEditorAddModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ThemesEditorAddModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports